import React, {useEffect} from 'react'
import { IframeResizer } from "@open-iframe-resizer/react";

import {Block} from 'blocks/block'
import {DPEloquaBlock} from 'types/DPTypes'
import InnerHTML from 'dangerously-set-html-content'
import {Theme} from '../../layout/theme'
import css from './eloqua.module.scss'
import {fromModule} from 'util/styler/Styler'
import {scrollToHash} from 'util/link'
import {useIDFromAnchorBlock} from 'util/useAnchor'
import {useSearchParams} from 'next/navigation'
import {useTranslation} from 'util/i18'

const styles = fromModule(css)

export const Eloqua: React.FC<DPEloquaBlock> = (data) => {
	const t = useTranslation()
	const searchParams = useSearchParams()
	const anchorID = useIDFromAnchorBlock(data)
	const {
		_type,
		title,
		id,
		url: originalUrl,
		arialabel,
		is_contact_form,
		blocks,
		persons
	} = data
	const contactblock = searchParams.get('contactblock')
	const origin_url = searchParams.get('origin_url')
	const utm_source = searchParams.get('utm_source')
	const utm_campaign = searchParams.get('utm_campaign')
	const utm_medium = searchParams.get('utm_medium')
	const contactperson = searchParams.get('contactperson')
	const utmFields = {utm_source, utm_campaign, utm_medium}

	let url = originalUrl
	let paramsObj: Record<string, string> = {}
	if (contactblock) paramsObj['contactblock'] = contactblock
	if (origin_url) paramsObj['origin_url'] = origin_url
	if (contactperson) paramsObj['contactperson'] = contactperson
	if (utm_source) paramsObj['utm_source'] = utm_source
	if (utm_campaign) paramsObj['utm_campaign'] = utm_campaign
	if (utm_medium) paramsObj['utm_medium'] = utm_medium
	paramsObj.pageURL = origin_url

	if (is_contact_form) {
		if (blocks[`b${contactblock}`]) {
			paramsObj['contactName'] = blocks[`b${contactblock}`].name
			paramsObj['contactEmail'] = blocks[`b${contactblock}`].email
		}
		if (persons[`p${contactperson}`]) {
			paramsObj['contactName'] = persons[`p${contactperson}`].name
			paramsObj['contactEmail'] = persons[`p${contactperson}`].email
		}
	}

	Object.keys(utmFields).forEach((key) => {
		const value = utmFields[key]
		if (!value) return
		paramsObj[key] = value
	})

	const params = Object.keys(paramsObj)
		.filter((key) => paramsObj[key])
		.map((key) => `${key}=${encodeURIComponent(paramsObj[key])}`)
		.join('&')

	url += url.includes('?') ? `&${params}` : `?${params}`

	const ariaLabel = arialabel || t.eloqua.iframe_arialabel

	useEffect(() => {
		if (contactblock || contactperson || origin_url) scrollToHash(anchorID)
	})

	if (
		process.env.NEXT_PUBLIC_COMMUNICATIONS_URL &&
		url.startsWith(process.env.NEXT_PUBLIC_COMMUNICATIONS_URL)
	) {
		url = url.replace(process.env.NEXT_PUBLIC_COMMUNICATIONS_URL, '/iframe')

		return (
			<Block type={_type} anchorID={anchorID} className={styles.eloqua()}>
				<Theme.Container>
					{title && (
						<Theme.H2 className={styles.eloqua.title()} mod="blueline">
							{title}
						</Theme.H2>
					)}
					<div className={styles.eloqua.formcontainer()}>
						<IframeResizer
							frameBorder={0}
							src={url}
							style={{width: '100%'}}
						/>
					</div>
				</Theme.Container>
			</Block>
		)
	}

	return (
		<Block type={_type} anchorID={anchorID} className={styles.eloqua()}>
			<Theme.Container>
				{title && (
					<Theme.H2 className={styles.eloqua.title()} mod="blueline">
						{title}
					</Theme.H2>
				)}
				<InnerHTML
					className={styles.eloqua.formcontainer()}
					html={`<iframe
              id="form${id}"
              class="eloqua-form"
			  aria-label="${ariaLabel}"
              allowfullscreen=""
              frameborder="0"
              marginheight="0px"
              marginwidth="0px"
              name="Test iframe height"
              scrolling="no"
              src="${url}";
              style="border:0px #ffffff none;" width="100%"
          ></iframe>
          <script
            src="https://images.communication.imec-int.com/Web/InteruniversitairMicroElectronicaCentrum/%7Bd9cbc1b6-0dd5-40bf-972a-fee75c86ed41%7D_embed.js"
            type="application/javascript"
          ></script>`}
				/>
			</Theme.Container>
		</Block>
	)
}
